import { ChangeEvent, FormEvent, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Button, Form, Input, Label, Nav, NavItem } from "reactstrap";
import { EmailAddress, Login, Password, SignUp, UserName } from "../../../Constants/Constants";
import { SignUpData } from "../../../Data/Authentication/Authentication";
import { useAppDispatch } from "../../../ReduxToolkit/Hooks";
import { login } from "../../../ReduxToolkit/Reducers/AuthReducer";
import { Route } from "../../../Routers/RouteList";
import { dynamicImage, Image } from "../../../Utils";

const SignInClassicContainer = () => {
  const navigate = useNavigate();
  const Path = useLocation();
  const secondPart = Path.pathname
    .split("/")
    .slice(Path.pathname.split("/").length - 1)
    .map((item) => item.replace(/[!@#$%&*()_+{}[\]:;"'<>,.?/\\|`~\-=]/g, " "));
  const [credential, setCredential] = useState({ email: "test@gmail.com", password: "test123" });
  const dispatch = useAppDispatch();
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => setCredential({ ...credential, [event.target.name]: event.target.value });
  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();
    if (credential.email === "test@gmail.com" && credential.password === "test123") {
      toast.success("Login Success...!");
      if (secondPart[0] === "sign in classic") dispatch(login());
      navigate(Route.Messenger);
    } else toast.error("Please Enter valid User Email or Password...!");
  };

  return (
    <div className="login-page2 animat-rate">
      <div className="login-content-main">
        <div className="login-content2">
          <div className="template-tab">
            <Nav tabs>
              <NavItem>
                <Link className={`nav-link ${secondPart[0] === "sign in classic" ? "active" : ""}`} to={Route.SignInClassic}>
                  {Login}
                </Link>
              </NavItem>
              <NavItem>
                <Link className={`nav-link ${secondPart[0] === "sign up classic" ? "active" : ""}`} to={Route.SignUpClassic}>
                  {SignUp}
                </Link>
              </NavItem>
            </Nav>
          </div>
        </div>
        <div className="login-content">
          <div className="login-content-header">
            <Link to={Route.Home}>
              <Image className="img-fluid for-light m-auto" src={dynamicImage("logo/landing-logo.png")} alt="images" />
              <Image className="img-fluid for-dark m-auto" src={dynamicImage("logo/logo-white.png")} alt="images" />
            </Link>
          </div>
          <h3 className="text-center">{"Hello Everyone , We are chatzy"}</h3>
          <h6 className="text-center">{"Wellcome to chatzy please, login to your account."}</h6>
          <Form className="form2" onSubmit={handleSubmit}>
            {secondPart[0] === "sign up classic" && (
              <div className="form-group">
                <Label className="col-form-label">{UserName}</Label>
                <Input type="text" value={"Test User"} />
              </div>
            )}
            <div className="form-group">
              <Label className="col-form-label">{EmailAddress}</Label>
              <Input type="email" name="email" value={credential.email} onChange={(e) => handleChange(e)} />
            </div>
            <div className="form-group">
              <Label className="col-form-label">{Password}</Label>
              <Input type="password" autoComplete="off" name="password" value={credential.password} onChange={(e) => handleChange(e)} />
            </div>
            {secondPart[0] === "sign in classic" && (
              <div className="form-group">
                <div className="rememberchk">
                  <Input id="gridCheck1" type="checkbox" />
                  <Label className="ps-4" htmlFor="gridCheck1" check>
                    {"Remember Me."}
                  </Label>
                  <h6 className="pull-right">{"Forgot Password?"}</h6>
                </div>
              </div>
            )}
            <ul className="medialogo">
              {SignUpData.map((item, index) => (
                <li key={index}>
                  <a className={`icon-btn btn-${item.color} button-effect rouded15`} href={item.url}>
                    <i className={`fa fa-${item.icon}`} />
                  </a>
                </li>
              ))}
            </ul>
            <div className="form-group mb-0">
              <div className="buttons">
                <Button color="primary" className="button-effect">
                  {secondPart[0] === "sign in classic" ? Login : SignUp}
                </Button>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default SignInClassicContainer;
